<template>
  <v-menu
    :left="sidebar"
    origin="top center"
    transition="scale-transition"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        outlined
        color="#1E88E5"
        v-on="on"
        class="costa-border"
      >
        {{ $i18n.t('contact').toUpperCase() }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in contactOptions"
        class="mt-5 ml-2"
        :key="index"
      >
        <v-list-item-action>
          <a :href="item.link" class="normal-link" target="_blank">
            <v-icon>{{ item.icon }}</v-icon>
          </a>
        </v-list-item-action>
        <v-list-item-title>
          <a :href="item.link" class="normal-link" target="_blank">
            {{ $i18n.t(item.title_translation) + (item.colon ? ':' : '') }}
            {{ item.title }}
          </a>
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="mt-5 mb-3">
        <v-list-item-title style="text-align: center;">
          <v-btn
            small dark fab icon
            class="form-close csr-btn-color"
            @click="$emit('close')"
          >
            <v-icon small>close</v-icon>
          </v-btn>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ContactUsMenu',

  props: {
    contactOptions: {
      type: Array,
      default: () => [],
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
